import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Card, Button } from 'sa-ui';
import messages from './avgRankingTableMessages';
import LoadMore from './LoadMore';

import './AvgRankingTable.scss';

const AvgRankingTable = (props) => {
  const [expanded, setExpanded] = useState(props.expanded);
  const dataPaginated = expanded ? props.data : props.data.slice(0, 10);

  return (
    <Card style={{ overflowX: 'auto' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          marginBottom: '30px',
        }}
      >
        <h5 className="title mt-0">
          <i className="ti ti-stats-up mr-2" />
          {props.intl.formatMessage(messages.title)}
        </h5>
        <div>
          <Button onClick={props.exportXLSX}>
            {props.intl.formatMessage(messages.generateSpreadSheet)}
          </Button>
        </div>
      </div>
      <div>
        <table className="default-table text-smaller">
          <thead>
            <tr>
              <th>{props.intl.formatMessage(messages.studentName)}</th>
              {props.isSchoolView && <th>{props.intl.formatMessage(messages.class)}</th>}
              <th>LC</th>
              <th>CH</th>
              <th>CN</th>
              <th>MT</th>
              <th>{props.intl.formatMessage(messages.writing)}</th>
              <th>{props.intl.formatMessage(messages.avgObj)}</th>
              <th>
                {`${props.intl.formatMessage(messages.avg)} ( ${props.intl.formatMessage(
                  messages.objective,
                )} + ${props.intl.formatMessage(messages.writing)} )`}
              </th>
            </tr>
          </thead>
          <tbody>
            {dataPaginated.map((d) => (
              <tr>
                <td>{d.studentName}</td>
                {props.isSchoolView && <td>{d.groupName}</td>}
                <td>{d.LCGrade}</td>
                <td>{d.CHGrade}</td>
                <td>{d.CNGrade}</td>
                <td>{d.MTGrade}</td>
                <td>{d.writing ? d.writing : '-'}</td>
                <td>{d.avgGrade ? d.avgGrade : '-'}</td>
                <td>{d.avgGradeWriting ? d.avgGradeWriting : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!expanded && props.data.length > 10 && <LoadMore onClick={() => setExpanded(true)} />}
      </div>
    </Card>
  );
};

AvgRankingTable.propTypes = {};

AvgRankingTable.defaultProps = {
  data: [],
  expanded: false,
};

export default injectIntl(AvgRankingTable);
